import { StyledSkeleton } from './styles';

export default StyledSkeleton;
